// 11 §10.2, docs/83 PO9–PO10 — pings on the encounter board: sending one (a right-click menu's
// Ping, or Z over the square under the pointer; Shift for danger), at most one a second, and the
// small right-click menu the board opens when no hero is selected. The board's `board_ping` rows
// arrive in `session.ts`; the HUD draws them with the chart's `PingMark` (ui/encounter/BoardPings).
import { create } from 'zustand';
import { rpc } from '../net/reducers';
import { mayPing } from '../pings';
import { useEncounter } from './session';
import type { Tile } from '../sim/types';

/** Pings square `t` for the party; false while my last ping is still fresh. */
export function pingBoard(t: Tile, kind = 0): boolean {
  const id = useEncounter.getState().encounterId;
  if (!id || !mayPing()) return false;
  void rpc.pingBoard(id, t.x, t.y, kind);
  return true;
}

/** The board's right-click menu: where it opened (CSS px in the window) and the square under it. */
export interface BoardMenu { x: number; y: number; tile: Tile }
export const useBoardMenu = create<{ menu?: BoardMenu; open(m: BoardMenu): void; close(): void }>()((set) => ({
  open(menu) { set({ menu }); },
  close() { set({ menu: undefined }); },
}));
